import { render, staticRenderFns } from "./SessionTime.vue?vue&type=template&id=b52877ec&scoped=true&"
import script from "./SessionTime.vue?vue&type=script&lang=js&"
export * from "./SessionTime.vue?vue&type=script&lang=js&"
import style0 from "./SessionTime.vue?vue&type=style&index=0&id=b52877ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52877ec",
  null
  
)

export default component.exports